/**
 * @flow
 * @relayHash 394ee2bd43fa53c16c1bd59f8ea0d636
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedBomsContainer_boms$ref = any;
export type ItemSortField = "BOM_NUMBER" | "CREATED_AT" | "ITEM_NUMBER" | "NAME" | "PART_NUMBER" | "UPDATED_AT";
export type SortDirection = "ASC" | "DESC";
export type ItemSort = {|
  field: ItemSortField,
  direction: SortDirection,
|};
export type PaginatedBomsContainerQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
  sortBy?: ?ItemSort,
|};
export type PaginatedBomsContainerQueryResponse = {|
  +$fragmentRefs: PaginatedBomsContainer_boms$ref
|};
export type PaginatedBomsContainerQuery = {|
  variables: PaginatedBomsContainerQueryVariables,
  response: PaginatedBomsContainerQueryResponse,
|};
*/


/*
query PaginatedBomsContainerQuery(
  $count: Int!
  $cursor: String
  $search: String
  $sortBy: ItemSort
) {
  ...PaginatedBomsContainer_boms_3OXele
}

fragment PaginatedBomsContainer_boms_3OXele on Query {
  items(first: $count, after: $cursor, search: $search, sortBy: $sortBy, hasBom: true) {
    edges {
      cursor
      ...BomsTable_itemEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment BomsTable_itemEdges on ItemEdge {
  node {
    id
    bomNumber
    itemNumber
    partNumber
    name
    description
    bomComponentCount
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "ItemSort",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v2 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "hasBom",
    "value": true
  },
  (v1/*: any*/),
  (v2/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PaginatedBomsContainerQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "PaginatedBomsContainer_boms",
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/),
          (v2/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PaginatedBomsContainerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "items",
        "storageKey": null,
        "args": (v3/*: any*/),
        "concreteType": "ItemConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "id",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "bomNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itemNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "partNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "bomComponentCount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "items",
        "args": (v3/*: any*/),
        "handle": "connection",
        "key": "PaginatedBomsContainer_items",
        "filters": []
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PaginatedBomsContainerQuery",
    "id": null,
    "text": "query PaginatedBomsContainerQuery(\n  $count: Int!\n  $cursor: String\n  $search: String\n  $sortBy: ItemSort\n) {\n  ...PaginatedBomsContainer_boms_3OXele\n}\n\nfragment PaginatedBomsContainer_boms_3OXele on Query {\n  items(first: $count, after: $cursor, search: $search, sortBy: $sortBy, hasBom: true) {\n    edges {\n      cursor\n      ...BomsTable_itemEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment BomsTable_itemEdges on ItemEdge {\n  node {\n    id\n    bomNumber\n    itemNumber\n    partNumber\n    name\n    description\n    bomComponentCount\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f943b52050622f8a32709cbfdf637a85';
module.exports = node;
